import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { FEATURE_REGISTRY } from '../../features/featureRegistry';
import { useTrackEvent } from '../../hooks/useTrackEvent';
import BetaNotice from './BetaNotice';
import '../admin/admin.css';

export default function FeatureRoute({ featureId, children }) {
  const { user, loading, hasFeature } = useAuth();
  const track = useTrackEvent();

  useEffect(() => {
    if (!user || !featureId || !hasFeature(featureId)) return;
    const feature = FEATURE_REGISTRY.find((f) => f.id === featureId);
    track('tool_opened', {
      toolId:   featureId,
      toolName: feature?.label || featureId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, featureId]);

  if (loading) {
    return (
      <div className="auth-loading">
        <div className="auth-loading__spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasFeature(featureId)) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <BetaNotice featureId={featureId} />
      {children}
    </>
  );
}
